/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import { groupBy, some } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModuleExport from '../../components/ModuleExport';
import { downloadReportFunc } from '../../utils/export';

const getTitleType = titleType => {
  let type = '';
  if (titleType === 'movie') {
    type = 'Movie';
  } else if (titleType === 'series') {
    type = 'Show';
  }
  return type;
};

const GroupedTable = ({
  data,
  headerFormatter,
  defaultSorts,
  view,
  filters,
  queryMeta,
  width,
  height,
  rowHeight,
  showRank,
  titleName,
  dataSize
}) => {
  const [collapsedSections, setCollapsedSections] = useState([]);
  const [sortField, setSortField] = useState('totalVotes');
  const [sortDirection, setSortDirection] = useState('desc');
  const [sortedData, setSortedData] = useState([]);

  const formatData = data => {
    if (some(data)) {
      let groupedData = groupBy(data, item => item.contentId);
      let formattedData = [];
      Object.entries(groupedData).map(([contentID, showData]) => {
        let totalVotes = showData.reduce((s, a) => s + a.voteCount, 0);

        // Store them
        formattedData.push({
          contentId: showData[0].contentId,
          contentName: showData[0].contentName,
          networkName: showData[0].networkName,
          contentType: getTitleType(showData[0].contentType),
          releaseDate: showData[0].releaseDate,
          totalVotes: totalVotes,
          children: showData
        });

        return true;
      });

      setSortedData(
        formattedData.sort((a, b) => {
          if (sortDirection === 'asc') {
            return a[sortField] > b[sortField] ? 1 : -1;
          }
          return a[sortField] <= b[sortField] ? 1 : -1;
        })
      );
    }
    return true;
  };

  const toggleRow = id => {
    if (collapsedSections.includes(id)) {
      var updatedSectionsIncluded = collapsedSections.filter(
        item => item !== id
      );
      setCollapsedSections([...updatedSectionsIncluded]);
    } else {
      var updatedSectionsExcluded = collapsedSections;
      updatedSectionsExcluded.push(id);
      setCollapsedSections([...updatedSectionsExcluded]);
    }
  };

  const changeSort = field => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      if (field === 'totalVotes') {
        setSortDirection('desc');
      } else {
        setSortDirection('asc');
      }
    }
  };

  useEffect(() => {
    formatData(data);
  }, [data, sortField, sortDirection]);

  if (some(data)) {
    return (
      <div className="tvt-tabular-data-table__container">
        <ModuleExport
          fetchData
          tableDataDownload={downloadReportFunc(view, filters, queryMeta)}
          showTitle={titleName}
          tableClassName="cvmi-table__moviesSummary"
          csv
          xls
          png
        />

        <table className="table tvt-attribution_title-table">
          <tr>
            <th className="tvt-attribution_title-td-toggle"></th>
            <th
              className="tvt-attribution_title-td-title sortable"
              onClick={() => changeSort('contentName')}
            >
              Title
              <FontAwesomeIcon
                icon={sortDirection === 'asc' ? 'caret-up' : 'caret-down'}
                className={sortField === 'contentName' ? '' : 'hidden'}
              />
            </th>
            <th
              className="tvt-attribution_title-td-contenttype sortable"
              onClick={() => changeSort('contentType')}
            >
              Content Type
              <FontAwesomeIcon
                icon={sortDirection === 'asc' ? 'caret-up' : 'caret-down'}
                className={sortField === 'contentType' ? '' : 'hidden'}
              />
            </th>
            <th
              className="tvt-attribution_title-td-releasedate sortable"
              onClick={() => changeSort('releaseDate')}
            >
              Release Date
              <FontAwesomeIcon
                icon={sortDirection === 'asc' ? 'caret-up' : 'caret-down'}
                className={sortField === 'releaseDate' ? '' : 'hidden'}
              />
            </th>
            <th
              className="tvt-attribution_title-td-network sortable"
              onClick={() => changeSort('networkName')}
            >
              Originating Network/Studio
              <FontAwesomeIcon
                icon={sortDirection === 'asc' ? 'caret-up' : 'caret-down'}
                className={sortField === 'networkName' ? '' : 'hidden'}
              />
            </th>
            <th class="tvt-attribution_title-td-platform">Platform</th>
            <th
              className="tvt-attribution_title-td-votes sortable"
              onClick={() => changeSort('totalVotes')}
            >
              Votes
              <FontAwesomeIcon
                icon={sortDirection === 'asc' ? 'caret-up' : 'caret-down'}
                className={sortField === 'totalVotes' ? '' : 'hidden'}
              />
            </th>
            <th class="tvt-attribution_title-td-titlevotes">% Title Votes</th>
            <th class="tvt-attribution_title-td-platformvotes">
              % Platform Votes
            </th>
          </tr>
          {sortedData.map(showData => (
            <tbody>
              <tr>
                <td>
                  <FontAwesomeIcon
                    icon={
                      collapsedSections.indexOf(showData.contentId) !== -1
                        ? 'angle-right'
                        : 'angle-down'
                    }
                    className="toggle-trigger"
                    onClick={() => toggleRow(showData.contentId)}
                  />
                </td>
                <td>{showData.contentName}</td>
                <td>{showData.contentType}</td>
                <td>
                  {showData.releaseDate
                    ? moment(showData.releaseDate).format('MM/DD/YYYY')
                    : 'Unknown'}
                </td>
                <td>{showData.networkName}</td>
                <td></td>
                <td>{numeral(showData.totalVotes).format(',')}</td>
                <td></td>
                <td></td>
              </tr>

              {showData.children
                // Sort forces exceptions to the end
                .sort(function(a, b) {
                  var exceptions = ['Unofficial', 'Other'];
                  if (
                    exceptions.includes(a.platformName) &&
                    exceptions.includes(b.platformName)
                  ) {
                    if (a.platformName === 'Unofficial') {
                      return -1;
                    }
                    return 1;
                  }
                  if (exceptions.includes(a.platformName)) {
                    return 1;
                  }
                  if (exceptions.includes(b.platformName)) {
                    return -1;
                  }
                  return parseInt(b.voteCount) - parseInt(a.voteCount);
                })
                .map(platformData => (
                  <tr
                    className={
                      collapsedSections.indexOf(showData.contentId) !== -1
                        ? 'hidden'
                        : 'tvt-attribution_title-tr-subrow'
                    }
                  >
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{platformData.platformName}</td>
                    <td>{numeral(platformData.voteCount).format(',')}</td>
                    <td>
                      {numeral(platformData.titleVoteShare / 100).format(
                        '0.00%'
                      )}
                    </td>
                    <td>
                      {numeral(platformData.platformVoteShare / 100).format(
                        '0.00%'
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          ))}
        </table>
      </div>
    );
  }

  return (
    <div className="tvt-tabular-data-table__container">
      <table className="table tvt-attribution_title-table">
        <tr>
          <th class="tvt-attribution_title-td-toggle"></th>
          <th class="tvt-attribution_title-td-title">Title</th>
          <th class="tvt-attribution_title-td-contenttype">Content Type</th>
          <th class="tvt-attribution_title-td-releasedate">Release Date</th>
          <th class="tvt-attribution_title-td-network">
            Originating Network/Studio
          </th>
          <th class="tvt-attribution_title-td-platform">Platform</th>
          <th class="tvt-attribution_title-td-votes">Votes</th>
          <th class="tvt-attribution_title-td-titlevotes">% Title Votes</th>
          <th class="tvt-attribution_title-td-platformvotes">
            % Platform Votes
          </th>
        </tr>
        {new Array(5).fill(0).map((_, index) => (
          <tr>
            <td class="loading"></td>
            <td class="loading">
              <div class="loading_bar"></div>
            </td>
            <td class="loading">
              <div class="loading_bar"></div>
            </td>
            <td class="loading">
              <div class="loading_bar"></div>
            </td>
            <td class="loading">
              <div class="loading_bar"></div>
            </td>
            <td class="loading">
              <div class="loading_bar"></div>
            </td>
            <td class="loading">
              <div class="loading_bar"></div>
            </td>
            <td class="loading">
              <div class="loading_bar"></div>
            </td>
            <td class="loading">
              <div class="loading_bar"></div>
            </td>
          </tr>
        ))}
      </table>
    </div>
  );
};

GroupedTable.defaultProps = {
  width: 1160,
  height: 600,
  rowHeight: 40,
  defaultSorts: [],
  showRank: true
};

export default GroupedTable;
